// extracted by mini-css-extract-plugin
export default {"wrap":"aJ-z","subtitle":"bJ-z","contentWrap":"cJ-z","imgWrap":"dJ-z","heading":"eJ-z","copy":"fJ-z"};